import React, { useState } from 'react';
import styled from 'styled-components';
import { PAYMENT_LOGOS } from './paymentOptions';

const LogoImg = styled.img`
  height: ${({ $height }) => $height}px;
  width: auto;
  max-width: 64px;
  object-fit: contain;
  display: block;
`;

const Chip = styled.span`
  display: inline-flex;
  align-items: center;
  height: ${({ $height }) => $height}px;
  padding: 0 0.5rem;
  border-radius: 4px;
  font-size: ${({ $height }) => Math.max(8, Math.round($height * 0.36))}px;
  font-weight: 700;
  letter-spacing: 0.03em;
  white-space: nowrap;
`;

/**
 * Shows the logo for a payment method id from PAYMENT_LOGOS. If the image file
 * is missing or fails to load, it swaps to a text chip instead of a broken icon.
 */
const PaymentLogo = ({ id, height = 24 }) => {
  const [failed, setFailed] = useState(false);
  const logo = PAYMENT_LOGOS[id];
  if (!logo) return null;

  if (logo.src && !failed) {
    return (
      <LogoImg
        src={logo.src}
        alt={logo.label}
        title={logo.label}
        $height={height}
        onError={() => setFailed(true)}
      />
    );
  }

  return (
    <Chip
      $height={height}
      style={{ background: logo.chip.bg, color: logo.chip.color }}
      title={logo.label}
      aria-label={logo.label}
    >
      {logo.chip.text}
    </Chip>
  );
};

export default PaymentLogo;

